import { Command } from '@ckeditor/ckeditor5-core';
import { first } from '@ckeditor/ckeditor5-utils';
export default class InsertResourcesCommand extends Command {
    refresh() {
        this.value = this._getValue();
        this.isEnabled = this._checkEnabled();
    }
    execute(options) {
        const model = this.editor.model;
        const schema = model.schema;
        const selection = model.document.selection;
        const blocks = Array.from(selection.getSelectedBlocks());
        const value = !options || options.forceValue === undefined ? !this.value : options.forceValue;
        model.change((writer) => {
            if (!value) {
                this._removeResources(writer, blocks.filter(findResources));
            }
            else {
                const blocksResources = blocks.filter((block) => {
                    return findResources(block) || checkCanBe(schema, block);
                });
                this._applyResources(writer, blocksResources);
            }
        });
    }
    _getValue() {
        const selection = this.editor.model.document.selection;
        const firstBlock = first(selection.getSelectedBlocks());
        return !!(firstBlock && findResources(firstBlock));
    }
    _checkEnabled() {
        if (this.value) {
            return true;
        }
        const selection = this.editor.model.document.selection;
        const schema = this.editor.model.schema;
        const firstBlock = first(selection.getSelectedBlocks());
        if (!firstBlock) {
            return false;
        }
        return checkCanBe(schema, firstBlock);
    }
    _removeResources(writer, blocks) {
        getRangesOfBlockGroups(writer, blocks)
            .reverse()
            .forEach((groupRange) => {
            if (groupRange.start.isAtStart && groupRange.end.isAtEnd) {
                writer.unwrap(groupRange.start.parent);
                return;
            }
            if (groupRange.start.isAtStart) {
                const positionBefore = writer.createPositionBefore(groupRange.start.parent);
                writer.move(groupRange, positionBefore);
                return;
            }
            if (!groupRange.end.isAtEnd) {
                writer.split(groupRange.end);
            }
            const positionAfter = writer.createPositionAfter(groupRange.end.parent);
            writer.move(groupRange, positionAfter);
        });
    }
    _applyResources(writer, blocks) {
        let resourcesToMerge = [];
        getRangesOfBlockGroups(writer, blocks)
            .reverse()
            .forEach((groupRange) => {
            let resources = findResources(groupRange.start);
            if (!resources) {
                resources = writer.createElement('resources');
                writer.wrap(groupRange, resources);
            }
            resourcesToMerge.push(resources);
        });
        resourcesToMerge.reverse().reduce((currentResources, nextResources) => {
            if (currentResources.nextSibling == nextResources) {
                writer.merge(writer.createPositionAfter(currentResources));
                return currentResources;
            }
            return nextResources;
        });
    }
}
function findResources(elementOrPosition) {
    var _a;
    return ((_a = elementOrPosition === null || elementOrPosition === void 0 ? void 0 : elementOrPosition.parent) === null || _a === void 0 ? void 0 : _a.name) == 'resources' ? elementOrPosition.parent : null;
}
function getRangesOfBlockGroups(writer, blocks) {
    let startPosition = null;
    let i = 0;
    const ranges = [];
    while (i < blocks.length) {
        const block = blocks[i];
        const nextBlock = blocks[i + 1];
        if (!startPosition) {
            startPosition = writer.createPositionBefore(block);
        }
        if (!nextBlock || block.nextSibling != nextBlock) {
            ranges.push(writer.createRange(startPosition, writer.createPositionAfter(block)));
            startPosition = null;
        }
        i++;
    }
    return ranges;
}
function checkCanBe(schema, block) {
    const isResourcesAllowed = schema.checkChild(block.parent, 'resources');
    const isBlockAllowedInResources = schema.checkChild(['$root', 'resources'], block);
    return isResourcesAllowed && isBlockAllowedInResources;
}
